const EmailSentIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="428"
      height="428"
      viewBox="0 0 428 428"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M106.094 246.944C106.094 246.944 100.955 238.351 96.2368 237.929C91.5189 237.508 35.3463 272.761 26.7537 291.111C18.1612 309.46 10.0304 346.28 32.7765 381.714C54.9605 416.184 89.7322 415.04 107.76 413.313C125.789 411.587 137.874 405.725 156.144 391.069C174.413 376.414 191.176 354.832 193.605 340.176C196.035 325.521 187.101 317.37 181.399 315.342C175.698 313.315 142.713 313.716 118.682 289.244C94.6508 264.771 106.094 246.944 106.094 246.944Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M113.377 235.78C113.377 235.78 98.8019 241.362 89.7877 251.219C80.7736 261.076 75.2126 276.535 74.791 299.261C74.3694 321.987 81.6569 347.704 109.944 358.866C138.231 370.029 163.547 361.436 171.698 353.707C179.849 345.978 189.766 324.135 189.766 324.135C189.766 324.135 144.756 336.18 123.315 310.824C101.873 285.468 113.377 235.78 113.377 235.78Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M365.29 251.62C354.288 235.117 328.029 230.239 307.27 223.513C286.512 216.788 274.286 203.437 279.786 170.392C285.287 137.347 313.916 83.6638 313.374 73.8868C312.832 64.1098 214.439 64.7322 205.264 67.864C196.09 70.9959 194.283 70.2932 185.73 81.2949C180.991 87.2363 176.702 93.5242 172.902 100.106L183.502 77.8217H184.285C185.437 74.8929 187.072 72.1783 189.123 69.7913C198.451 58.9696 203.737 45.2474 204.08 30.9643C204.481 9.94472 189.525 11.9724 186.694 18.4369C183.863 24.9014 167.301 47.1456 162.442 53.2085C157.584 59.2715 147.486 75.8543 147.486 75.8543L136.263 114.762C136.263 114.762 133.814 126.366 119.761 170.352C105.707 214.339 111.831 234.615 111.831 234.615C111.831 234.615 108.157 232.788 99.6043 259.048C91.0519 285.307 94.7258 318.894 109.984 334.775C125.241 350.655 145.418 350.052 168.023 340.898C181.929 334.94 193.51 324.606 201.008 311.466C201.008 311.466 224.838 305.443 242.545 291.932C260.252 278.421 273.683 264.448 299.381 265.673C325.078 266.898 354.349 281.553 364.126 280.931C373.903 280.308 376.292 268.102 365.29 251.62Z"
        fill="white"
      />
      <path
        d="M365.29 251.62C354.288 235.117 328.029 230.239 307.27 223.513C286.512 216.788 274.286 203.437 279.786 170.392C285.287 137.347 313.916 83.6638 313.374 73.8868C312.832 64.1098 214.439 64.7322 205.264 67.864C196.09 70.9959 194.283 70.2932 185.73 81.2949C180.991 87.2363 176.702 93.5242 172.902 100.106L183.502 77.8217H184.285C185.437 74.8929 187.072 72.1783 189.123 69.7913C198.451 58.9696 203.737 45.2474 204.08 30.9643C204.481 9.94472 189.525 11.9724 186.694 18.4369C183.863 24.9014 167.301 47.1456 162.442 53.2085C157.584 59.2715 147.486 75.8543 147.486 75.8543L136.263 114.762C136.263 114.762 133.814 126.366 119.761 170.352C105.707 214.339 111.831 234.615 111.831 234.615C111.831 234.615 108.157 232.788 99.6043 259.048C91.0519 285.307 94.7258 318.894 109.984 334.775C125.241 350.655 145.418 350.052 168.023 340.898C181.929 334.94 193.51 324.606 201.008 311.466C201.008 311.466 224.838 305.443 242.545 291.932C260.252 278.421 273.683 264.448 299.381 265.673C325.078 266.898 354.349 281.553 364.126 280.931C373.903 280.308 376.292 268.102 365.29 251.62Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M365.634 280.791C365.634 280.791 366.919 275.652 352.344 268.746C337.768 261.84 331.766 266.598 331.766 270.031C331.766 273.464 363.385 280.791 365.634 280.791Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.529 45.5593L190.75 73.8665H240.076C240.076 73.8665 240.076 39.0948 227.529 45.5593Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M181.397 249.734C186.621 243.831 193.133 239.208 200.429 236.223"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M174.712 260.716C175.276 259.084 176.009 257.517 176.9 256.038"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M160.058 298.859C158.091 297.128 156.253 295.256 154.558 293.258"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.009 311.468C189.666 312.758 178.206 310.41 168.285 304.762"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M338.531 71.438H153.189C127.592 71.438 106.854 91.253 106.854 115.605V202.936C106.854 224.176 122.533 241.923 143.452 246.2L133.675 275.129L178.926 247.264H338.531C364.107 247.264 384.866 227.449 384.866 203.096V115.766C384.866 91.253 364.107 71.438 338.531 71.438Z"
        fill="#85C553"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M137.027 130.24H345.376"
        stroke="black"
        strokeWidth="2.06409"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M137.027 151.703H345.376"
        stroke="black"
        strokeWidth="2.06409"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M137.027 173.143H345.376"
        stroke="black"
        strokeWidth="2.06409"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M137.027 194.586H345.376"
        stroke="black"
        strokeWidth="2.06409"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M383.178 147.989C397.448 147.989 409.016 136.943 409.016 123.316C409.016 109.689 397.448 98.6425 383.178 98.6425C368.908 98.6425 357.34 109.689 357.34 123.316C357.34 136.943 368.908 147.989 383.178 147.989Z"
        fill="black"
      />
      <path
        d="M381.84 133.802C381.281 132.686 381.031 131.442 381.114 130.197V116.994L378.13 118.658C377.808 118.844 377.445 118.944 377.073 118.948C376.795 118.951 376.519 118.895 376.265 118.783C376.01 118.672 375.781 118.508 375.595 118.301C375.206 117.898 374.992 117.357 375 116.796C374.992 116.415 375.103 116.041 375.317 115.727C375.626 115.358 375.991 115.042 376.4 114.789L382.183 111.832C382.829 111.369 383.584 111.082 384.375 111C386.342 111 387.319 112.479 387.319 115.436V130.66C387.319 133.551 386.289 134.99 384.216 134.99C383.749 135.031 383.279 134.942 382.86 134.732C382.44 134.523 382.087 134.2 381.84 133.802Z"
        fill="white"
      />
      <path
        d="M284.045 58.5102C284.045 58.5102 284.868 74.6714 299.423 82.3605C313.978 90.0496 332.569 88.3833 332.97 78.7267C333.372 69.0702 322.049 58.9117 314.38 45.9627C306.711 33.0137 289.706 40.3213 282.439 49.215"
        fill="white"
      />
      <path
        d="M284.045 58.5102C284.045 58.5102 284.868 74.6714 299.423 82.3605C313.978 90.0496 332.569 88.3833 332.97 78.7267C333.372 69.0702 322.049 58.9117 314.38 45.9627C306.711 33.0137 289.706 40.3213 282.439 49.215"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M309.119 71.4374C307.894 77.9018 312.351 81.4754 316.386 83.483C320.422 85.4906 328.432 84.3061 332.969 78.6447C333.17 73.9067 330.58 69.0885 326.946 63.8888C321.887 64.5312 310.063 66.3782 309.119 71.4374Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M253.732 58.5102C253.732 58.5102 254.535 74.6714 269.09 82.3605C283.646 90.0496 302.256 88.3833 302.658 78.7267C303.059 69.0702 291.736 58.9117 284.047 45.9627C276.358 33.0137 259.394 40.3213 252.106 49.215"
        fill="white"
      />
      <path
        d="M253.732 58.5102C253.732 58.5102 254.535 74.6714 269.09 82.3605C283.646 90.0496 302.256 88.3833 302.658 78.7267C303.059 69.0702 291.736 58.9117 284.047 45.9627C276.358 33.0137 259.394 40.3213 252.106 49.215"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M278.805 71.4374C277.58 77.9018 282.037 81.4754 286.072 83.483C290.108 85.4906 298.118 84.3061 302.655 78.6447C302.836 73.9067 300.246 69.0885 296.632 63.8888C291.573 64.5312 279.748 66.3782 278.805 71.4374Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.522 58.5102C225.522 58.5102 226.325 74.6714 240.88 82.3605C255.435 90.0496 274.026 88.3833 274.427 78.7267C274.829 69.0702 263.526 58.9117 255.837 45.9627C248.148 33.0137 231.163 40.3213 223.896 49.215"
        fill="white"
      />
      <path
        d="M225.522 58.5102C225.522 58.5102 226.325 74.6714 240.88 82.3605C255.435 90.0496 274.026 88.3833 274.427 78.7267C274.829 69.0702 263.526 58.9117 255.837 45.9627C248.148 33.0137 231.163 40.3213 223.896 49.215"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M250.578 71.4374C249.373 77.9018 253.81 81.4754 257.865 83.483C261.921 85.4906 269.911 84.3061 274.428 78.6447C274.629 73.9067 272.039 69.0885 268.405 63.8888C263.346 64.5312 251.521 66.3782 250.578 71.4374Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.833 234.616C111.833 234.616 112.958 259.47 126.67 276.193"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.9205 338.35C71.9205 343.409 68.5478 347.505 64.392 347.505C60.2363 347.505 56.8635 343.489 56.8635 338.35C56.8635 333.21 60.2363 329.195 64.392 329.195C68.5478 329.195 71.9205 333.291 71.9205 338.35Z"
        fill="white"
      />
      <path
        d="M53.191 349.753C53.191 354.812 49.8183 358.907 45.6625 358.907C41.5068 358.907 38.134 354.892 38.134 349.753C38.134 344.613 41.5068 340.578 45.6625 340.578C49.8183 340.578 53.191 344.694 53.191 349.753Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmailSentIcon;
